// UI/UX and device-related hooks
export * from "./useDevice";
export * from "./useResponsiveTypography";
export * from "./useCarousel";
export * from "./useSwipeGesture";
export * from "./usePreventScroll";
export * from "./useWidgetEventListeners";
export * from "./useWavyTextAnimation";
export * from "./useConfettiOnce";
export * from "./useElementHeight";
export * from "./useContainerWidth";
export * from "./useClipboard";
export * from "./useAutoScrollToElement";
export * from "./useScrollToHighlight";
export * from "./useClickOutside";
export * from "./useEscapeKey";
export * from "./useDraggable";
export * from "./useFlipAnimation";
export * from "./useLeaderboardFlipAnimation";
export * from "./useNewFeatureBadge";
export * from "./useScrollVisibility";
export * from "./useIsStandalonePage";
export * from "./useValueFlash";
export * from "./useChartResize";
export * from "./useEntranceAnimation";
